var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('div',_vm._g({staticClass:"d-inline"},on),[_c('RichTextEditorToolbarVue',{attrs:{"id":_vm.toolbarId,"include-link":_vm.includeLink}})],1)]}}])},[_c('span',[_vm._v(_vm._s(_vm.$t("Format text")))])])}
var staticRenderFns = []

export { render, staticRenderFns }